import i18n from 'modules/core/lib/i18n'
import AccessGroup from 'modules/core/store/models/AccessGroup'

export default function reviewsRespondentRole(list: string[]): string[] {
  const values = {
    [AccessGroup.Strategies.self]: i18n.t(
      'custom_reports.especial_filters.reviews_respondent_role.options.self'
    ),
    [AccessGroup.Strategies.manager]: i18n.t(
      'custom_reports.especial_filters.reviews_respondent_role.options.manager'
    ),
    [AccessGroup.Strategies.reportees]: i18n.t(
      'custom_reports.especial_filters.reviews_respondent_role.options.reportees'
    ),
    [AccessGroup.Strategies.peers]: i18n.t(
      'custom_reports.especial_filters.reviews_respondent_role.options.peers'
    ),
  }

  return list.map((value) => values[value]).filter((value): value is string => value !== undefined)
}
